import { Box, Slider, styled, Tooltip } from "@mui/material";
// import type { SliderValueLabelProps } from "@mui/material" (needs a version upgrade);

const ValueLabelComponent = ({ children, value }: any) => (
  <Tooltip enterTouchDelay={0} placement="top" title={value}>
    {children}
  </Tooltip>
);

const ProgressSlider = styled(Slider)({
  color: "#239B8B",
  height: 6,
  padding: 0,
  margin: 0,
  maxHeight: "100%",
  "& .MuiSlider-track": {
    border: "none",
    borderRadius: 0,
  },
  "& .MuiSlider-rail": {
    opacity: 0.8,
    backgroundColor: "#D9D9D9CC",
    borderRadius: 0,
  },
  "& .MuiSlider-thumb": {
    height: 6,
    width: 6,
    backgroundColor: "#239B8B",
    border: "2px solid currentColor",
    borderRadius: 0,
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&::before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "#52af77",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

interface TSProgressBarProps {
  value: number;
  handleProgressBarSeek: (event: Event, value: number | number[], activeThumb: number) => void;
  handleProgressBarMouseDown: React.MouseEventHandler<HTMLSpanElement>;
  handleProgressBarMouseUp: (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]) => void;
  formattedCurrentTime: string;
}

const TSProgressBar = ({
  value,
  handleProgressBarSeek,
  handleProgressBarMouseDown,
  handleProgressBarMouseUp,
  formattedCurrentTime,
}: TSProgressBarProps) => (
  <Box sx={{ display: "flex", alignItems: "flex-start" }}>
    <ProgressSlider
      min={0}
      max={100}
      value={value}
      aria-label="progress bar"
      onChange={handleProgressBarSeek}
      onMouseDown={handleProgressBarMouseDown}
      onChangeCommitted={handleProgressBarMouseUp}
      valueLabelDisplay="auto"
      components={{
        ValueLabel: (props) => <ValueLabelComponent {...props} value={formattedCurrentTime} />,
      }}
    />
  </Box>
);

export default TSProgressBar;
